(() => {
  const gardenSelector = '[data-build-your-garden]';
  let lastProductId = null;
  let requestNumber = 0;

  const root = window.Shopify?.routes?.root || '/';
  const requestJson = (url, options = {}) => new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open(options.method || 'GET', url, true);
    request.setRequestHeader('Accept', 'application/json');
    request.onload = () => {
      if (request.status < 200 || request.status >= 300) {
        reject(new Error(`Request failed: ${request.status}`));
        return;
      }
      try {
        resolve(JSON.parse(request.responseText));
      } catch (error) {
        reject(error);
      }
    };
    request.onerror = () => reject(new Error('Network request failed'));
    request.send(options.body || null);
  });
  const money = value => {
    const cents = typeof value === 'string' ? Math.round(Number.parseFloat(value) * 100) : value;
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'CAD'
    }).format(cents / 100);
  };

  const getCart = () => requestJson(`${root}cart.js`);

  const getClassicCandles = async () => {
    const url = `${root}collections/classic-candles/products.json?limit=12`;
    const data = await requestJson(url);
    return data.products || [];
  };

  const renderShippingProgress = cart => {
    const progress = document.querySelector('[data-shipping-progress]');
    if (!progress) return;
    const threshold = Number(progress.dataset.freeShippingThreshold) || 14900;
    const remaining = Math.max(0, threshold - cart.total_price);
    const percentage = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    const message = progress.querySelector('[data-shipping-message]');
    const fill = progress.querySelector('[data-shipping-fill]');
    message.textContent = remaining > 0
      ? `${money(remaining)} AWAY FROM FREE SHIPPING · C$10 FLAT-RATE SHIPPING`
      : 'YOU\'VE UNLOCKED FREE SHIPPING';
    fill.style.width = `${percentage}%`;
  };

  const productCard = product => {
    const variant = product.variants?.find(item => item.available) || product.variants?.[0];
    if (!variant) return '';
    const image = product.featured_image || product.images?.[0];
    const imageUrl = typeof image === 'string' ? image : image?.url || image?.src;
    return `
      <article class="quick-cart__garden-product" data-product-id="${product.id}">
        <a class="quick-cart__garden-link" href="${product.url || `${root}products/${product.handle}`}">
          ${imageUrl ? `<img class="quick-cart__garden-image" src="${imageUrl}" alt="" loading="lazy">` : ''}
          <span class="quick-cart__garden-name">${product.title}</span>
          <span class="quick-cart__garden-price">${money(variant.price)}</span>
        </a>
        <form class="quick-cart__garden-form" action="${root}cart/add" method="post">
          <input type="hidden" name="id" value="${variant.id}">
          <input type="hidden" name="quantity" value="1">
          <button class="quick-cart__garden-add" type="submit" ${variant.available ? '' : 'disabled'}>
            ${variant.available ? 'Add to cart' : 'Sold out'}
          </button>
        </form>
      </article>`;
  };

  const renderGarden = async () => {
    const garden = document.querySelector(gardenSelector);
    if (!garden) return;

    const cart = await getCart();
    renderShippingProgress(cart);
    if (!cart.items?.length) {
      garden.replaceChildren();
      lastProductId = null;
      return;
    }

    const productId = cart.items[0].product_id;
    if (!productId || (productId === lastProductId && garden.children.length)) return;
    lastProductId = productId;
    const currentRequest = ++requestNumber;

    let products = await getClassicCandles();
    if (currentRequest !== requestNumber) return;

    const cartProductIds = new Set(cart.items.map(item => item.product_id));
    products = products
      .filter(product => !cartProductIds.has(product.id))
      .filter(product => !/(bundle|choose any)/i.test(product.title))
      .filter(product => {
        const price = Number.parseFloat(product.variants?.[0]?.price || '0');
        return price > 0 && price <= 60;
      })
      .slice(0, 3);
    garden.innerHTML = products.length ? `
      <div class="quick-cart__garden-inner">
        <h3 class="quick-cart__garden-title">Complete Your Purchase</h3>
        <div class="quick-cart__garden-grid">${products.map(productCard).join('')}</div>
      </div>` : '';
  };

  document.addEventListener('submit', async event => {
    const form = event.target.closest('.quick-cart__garden-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    button.disabled = true;
    try {
      await requestJson(`${root}cart/add.js`, {
        method: 'POST',
        body: new FormData(form)
      });
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true }));
      lastProductId = null;
      await renderGarden();
    } catch (error) {
      form.submit();
    } finally {
      button.disabled = false;
    }
  });

  ['cart:updated', 'quick-cart:open', 'cart:item-added', 'apps:product-added-to-cart'].forEach(eventName => {
    document.addEventListener(eventName, () => window.setTimeout(renderGarden, 75));
    window.addEventListener(eventName, () => window.setTimeout(renderGarden, 75));
  });

  new MutationObserver(() => {
    const cart = document.querySelector('[data-quick-cart]');
    if (cart?.classList.contains('active') || cart?.classList.contains('visible')) renderGarden();
  }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['class'] });
})();



/* Keep the native drawer's quantity visible after every theme render. */
(() => {
  const items = document.querySelector('[data-quick-cart] [data-items]');
  if (!items) return;
  const renderQuantities = () => {
    items.querySelectorAll('.quick-cart__item').forEach(item => {
      const controls = item.querySelector('.quick-cart__control-top');
      const decrease = controls?.querySelector('[data-decrease]');
      const increase = controls?.querySelector('[data-increase]');
      if (!controls || !decrease || !increase) return;
      let quantity = controls.querySelector('[data-cart-quantity-display]');
      if (!quantity) {
        quantity = document.createElement('span');
        quantity.className = 'quick-cart__quantity-display';
        quantity.setAttribute('data-cart-quantity-display', '');
        quantity.setAttribute('role', 'status');
        controls.insertBefore(decrease, increase);
        controls.insertBefore(quantity, increase);
      }
      const value = item.dataset.quantity;
      if (quantity.textContent !== value) {
        quantity.textContent = value;
        quantity.setAttribute('aria-label', 'Quantity: ' + value);
      }
    });
  };
  renderQuantities();
  new MutationObserver(renderQuantities).observe(items, { childList: true });
})();

/* Crowfoot gift-set cards */

  (function () {
    var isTrio = window.location.pathname.indexOf('/products/classic-candle-bundle') !== -1;
    if (!isTrio && window.location.pathname.indexOf('/products/choose-any-four-classic-candles') === -1) return;
    var candleCount = isTrio ? 3 : 4;
    var countWord = isTrio ? 'three' : 'four';

    function escapeHtml(value) {
      var div = document.createElement('div');
      div.textContent = value;
      return div.innerHTML;
    }

    function initGiftSetBuilder() {
      var root = document.getElementById('simple-bundles-io-options');
      if (!root || root.classList.contains('cc-bundle-enhanced')) return false;

      var selects = Array.prototype.slice.call(root.querySelectorAll('select')).filter(function (select) {
        return /^properties\[(?:Choose candle|Candle )/i.test(select.name);
      });
      if (selects.length !== candleCount) return false;

      var options = Array.prototype.slice.call(selects[0].options).filter(function (option) {
        return option.value;
      });
      if (!options.length) return false;

      var builder = document.createElement('section');
      builder.className = 'cc-bundle-builder';
      builder.setAttribute('aria-label', 'Build your ' + countWord + '-candle gift set');
      builder.innerHTML =
        '<p class="cc-bundle-builder__eyebrow">' + (isTrio ? 'You save $13.20 (10%)' : 'You save $17.60 (10%) + free Canadian shipping') + '</p>' +
        '<h2 class="cc-bundle-builder__title">Build your gift set</h2>' +
        '<p class="cc-bundle-builder__intro">Choose any ' + countWord + ' scents. Mix, match, or add more than one of a favourite.</p>' +
        '<div class="cc-bundle-progress" aria-label="Your selected candles"></div>' +
        '<p class="cc-bundle-progress-text" aria-live="polite">0 of ' + candleCount + ' selected</p>' +
        '<div class="cc-scent-grid"></div>';

      root.insertBefore(builder, root.firstChild);
      root.classList.add('cc-bundle-enhanced');

      var values = new Array(candleCount).fill('');
      var slots = builder.querySelector('.cc-bundle-progress');
      if (isTrio) slots.style.gridTemplateColumns = 'repeat(3, minmax(0, 1fr))';
      var progress = builder.querySelector('.cc-bundle-progress-text');
      var grid = builder.querySelector('.cc-scent-grid');
      var form = root.closest('form');
      var addButton = form ? form.querySelector('button[name="add"], [data-add-to-cart]') : null;

      selects.forEach(function (select) {
        select.value = '';
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });


      var scentNotes = {
        "11:11 - Eleven Eleven - Classic Candle": "Apple Blossom · Oak · Vanilla Bean",
        "AAWAKAMA - Protect - Classic Candle": "Tobacco Flower · Cedar · Blackberry",
        "AISIYAH'KIYA - Cleanse - Classic Candle": "Balsam Fir · Oak Moss · Rain",
        "AWATSIMOIHKA - Gratitude - Classic Candle": "Palo Santo · Sandalwood · Cedar",
        "IISSTISOOHTSI - Forest Bathe - Classic Candle": "Balsam Fir · Red Cedar · Neroli",
        "PAPOA'KAN - Dreamcatcher - Classic Candle": "Jasmine · Sandalwood · Orchid",
        "Santa Monica - Sicilian Orange & Crushed Berries": "Sicilian Orange · Crushed Berries · Wild Mint",
        "SIIPATSIMAAN - Sweetgrass - Classic Candle": "Sweetgrass · Warm Earth · Wild Honey",
        "SOL - Palo Santo + Tonka Bean + Sandalwood": "Palo Santo · Tonka Bean · Sandalwood",
        "Todos Santos - Coconut Cream + Fresh Lime": "Coconut Cream · Fresh Lime · Honeycomb"
      };

      function splitName(value) {
        var clean = value.replace(/\s*-\s*Classic Candle$/i, '');
        var pieces = clean.split(' - ');
        return {
          ritual: pieces.length > 1 ? pieces.shift() : 'Crowfoot Classic',
          name: pieces.length ? pieces.join(' - ') : clean
        };
      }

      function render() {
        var count = values.filter(Boolean).length;
        progress.textContent = count + ' of ' + candleCount + ' selected';
        if (addButton) {
          addButton.disabled = count !== candleCount;
          addButton.setAttribute('aria-disabled', count !== candleCount ? 'true' : 'false');
        }

        slots.innerHTML = values.map(function (value, index) {
          var label = value ? splitName(value).name : 'Choose a scent';
          return '<button type="button" class="cc-bundle-slot' + (value ? ' is-filled' : '') +
            '" data-slot="' + index + '" aria-label="' + (value ? 'Remove ' + escapeHtml(value) : 'Candle ' + (index + 1) + ' is empty') + '">' +
            '<span class="cc-bundle-slot__number">Candle ' + (index + 1) + '</span>' +
            '<span class="cc-bundle-slot__name">' + escapeHtml(label) + '</span></button>';
        }).join('');

        Array.prototype.forEach.call(grid.querySelectorAll('.cc-scent-card'), function (card) {
          var quantity = values.filter(function (value) { return value === card.getAttribute('data-value'); }).length;
          card.classList.toggle('is-selected', quantity > 0);
          var oldCount = card.querySelector('.cc-scent-card__count');
          if (oldCount) oldCount.remove();
          if (quantity > 0) {
            var badge = document.createElement('span');
            badge.className = 'cc-scent-card__count';
            badge.textContent = quantity + '×';
            card.appendChild(badge);
          }
        });
      }

      grid.innerHTML = options.map(function (option) {
        var names = splitName(option.value);
        var notes = scentNotes[option.value] || '';
        return '<button type="button" class="cc-scent-card" data-value="' + escapeHtml(option.value) + '">' +
          '<span class="cc-scent-card__ritual">' + escapeHtml(names.ritual) + '</span>' +
          '<span class="cc-scent-card__name">' + escapeHtml(names.name) + '</span>' +
          '<span class="cc-scent-card__notes">' + escapeHtml(notes) + '</span>' +
          '<span class="cc-scent-card__add" aria-hidden="true">+</span></button>';
      }).join('');

      grid.addEventListener('click', function (event) {
        var card = event.target.closest('.cc-scent-card');
        if (!card) return;
        var emptyIndex = values.indexOf('');
        var targetIndex = emptyIndex === -1 ? candleCount - 1 : emptyIndex;
        values[targetIndex] = card.getAttribute('data-value');
        selects[targetIndex].value = values[targetIndex];
        selects[targetIndex].dispatchEvent(new Event('change', { bubbles: true }));
        render();
      });

      slots.addEventListener('click', function (event) {
        var slot = event.target.closest('.cc-bundle-slot');
        if (!slot) return;
        var index = Number(slot.getAttribute('data-slot'));
        if (!values[index]) return;
        values[index] = '';
        selects[index].value = '';
        selects[index].dispatchEvent(new Event('change', { bubbles: true }));
        render();
      });

      render();
      return true;
    }

    function start() {
      if (initGiftSetBuilder()) return;
      var observer = new MutationObserver(function () {
        if (initGiftSetBuilder()) observer.disconnect();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
      var attempts = 0;
      var retryTimer = window.setInterval(function () {
        attempts += 1;
        if (initGiftSetBuilder() || attempts > 240) window.clearInterval(retryTimer);
      }, 250);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  
